"use client";

import { useContext } from "react";
import { ResourceContext } from "@/contexts/resource-context";
import { logEvent } from "@/service/logs/log";
import { Button } from "@/components/ui/button";

export const Preview = ({ preview }: { preview: string }) => {
  const { logView } = useContext(ResourceContext);

  return (
    <div className={`mb-8 text-center`}>
      <Button
        variant={"blue"}
        onClick={() => {
          logEvent("ebook_preview_download", logView);
        }}
        asChild={true}
      >
        <a target={"_blank"} href={preview}>
          Pobierz darmową próbkę e-booka
        </a>
      </Button>
    </div>
  );
};
